import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import {
  numberFormat,
  toTitleCase,
  getAddress,
  toWords,
  underlineData,
  underlineData1,
} from '../../constants/constants';
import { ToWords } from 'to-words';

const numToWords = new ToWords({
  localeCode: 'en-US',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
  },
});

const roman = 'Times-Roman';
const timesBold = 'Times-Bold';
const formName = 'Form 289R (Non-Stocked) Rev. 6/2017';
const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    margin: 5,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
  },

  content: {
    padding: 25,
    '@media max-width: 400': {
      flexDirection: 'column',
    },
    '@media min-width: 400': {
      flexDirection: 'row',
    },
    flexDirection: 'column',
    display: 'flex',
    fontSize: 9,
    textAlign: 'justify',
    fontFamily: roman,
  },
  text: {
    margin: 1,
    marginBottom: 5,
    textIndent: 28,
    letterSpacing: 0.5,
    justifyContent: 'space-evenly',
  },
  title: {
    marginBottom: 5,
    marginTop: 5,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: timesBold,
  },
  subTitle: {
    fontWeight: 1000,
    textAlign: 'left',
    fontSize: 10,
    fontFamily: timesBold,
  },
  notary: {
    flexDirection: 'row',
    marginTop: 20,
    justifyContent: 'space-between',
    fontFamily: timesBold,
  },
  subNotary: {
    alignItems: 'center',
    // marginLeft: 20,
    // marginRight: 20,
  },
  border: {
    borderWidth: 1.5,
    borderStyle: 'solid',
    marginTop: 5,
    borderRadius: 1,
  },
  dynamicData: {
    textDecoration: 'underline',
  },
  instruct: {
    paddingBottom: 8,
  },
  pageNumbers: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 9,
    fontFamily: roman,
    flexDirection: 'row',
  },
  formNumber: {
    textAlign: 'right',
    marginRight: 20,
    paddingRight: 10,
  },
});

const MediaComponent = props => (
  <View style={[styles.content]}>
    <View style={{ flexDirection: 'row' }}>
      <View style={{ flexBasis: '58%' }}>
        <Text>
          District :
          <Text style={styles.dynamicData}>
            {underlineData(props.data.district)}
          </Text>{' '}
        </Text>
        <Text>
          Bond # :
          <Text style={styles.dynamicData}>
            {underlineData1(props.data.bondNumber, 55)}
          </Text>{' '}
        </Text>
        <Text>
          <Text style={styles.dynamicData}>
            {underlineData1(props.data.taxId, 67)}
          </Text>{' '}
        </Text>
        <Text>Principal&apos;s Social Security No. or Tax I.D.</Text>
      </View>
      <View style={{ flexBasis: '42%' }}>
        <Text>
          Account No :{' '}
          <Text style={styles.dynamicData}>
            {underlineData(props.data.billAccount)}
          </Text>{' '}
        </Text>
        <Text wrap="true">
          Service Address :{' '}
          <Text style={styles.dynamicData}>
            {getAddress(props.data.street, props.data.streetline2)},{' '}
            {toTitleCase(props.data.city)}, {props.data.state}{' '}
            {toTitleCase(props.data.zipCode)}
          </Text>
        </Text>
        <Text style={{ fontFamily: timesBold }}>
          Various Service Address :{' '}
        </Text>
        <Text></Text>
      </View>
    </View>

    <View>
      <Text style={[styles.title, { fontFamily: timesBold }]}>SURETY BOND</Text>
    </View>

    <View>
      <Text style={styles.subTitle}>KNOW ALL PERSONS BY THESE PRESENTS:</Text>
    </View>

    <View>
      <Text style={[styles.text, { textIndent: 0 }]}>
        THAT WE,{' '}
        <Text style={styles.dynamicData}>
          {toTitleCase(props.data.companyName)}
        </Text>{' '}
        as Principal at (mailing address){' '}
        <Text style={styles.dynamicData}>
          {getAddress(props.data.street, props.data.streetline2)},{' '}
          {toTitleCase(props.data.city)}, {props.data.state}
          {toTitleCase(props.data.zipCode)}
        </Text>{' '}
        and{' '}
        <Text style={styles.dynamicData}>
          {toTitleCase(props.data.insuranceCompanyName)}
        </Text>
        , a surety company at (mailing address){' '}
        <Text style={styles.dynamicData}>
          {getAddress(
            props.data.insuranceCompanyStrAddr,
            props.data.insuranceCompanyStrAddrLn2,
          )}
          , {toTitleCase(props.data.insuranceCompanyCity)},{' '}
          {props.data.insuranceCompanyState}{' '}
          {toTitleCase(props.data.insuranceCompanyZipCode)}
        </Text>{' '}
        authorized to do business in the State of Florida, as Surety are held
        and firmly bound to Florida Power & Light Company, a corporation
        organized and existing under the laws of the State of Florida, its
        successors and assigns, in the amount of{' '}
        <Text style={styles.dynamicData}>
          {' '}
          {toWords(numToWords, props.data.depositBondAmt)}
        </Text>
        dollars (
        <Text style={styles.dynamicData}>
          {' '}
          {numberFormat(props.data.depositBondAmt)}
        </Text>
        ), lawful money of the United States of America for the payment of which
        the Principal and Surety, their heirs, executors, administrators,
        successors and assigns are hereby jointly and severally bound.
      </Text>
    </View>

    <View>
      <Text style={[styles.text]}>
        WHEREAS, pursuant to its authorized General Rules and Regulations for
        Electric Service, Florida Power & Light Company requires the Principal
        to establish credit for prompt payment of its monthly utility bills, and
        Principal and Florida Power & Light Company agree that Principal may do
        so by furnishing this surety bond for prompt payment of the monthly
        utility bills to be rendered by Florida Power & Light Company;
      </Text>
    </View>

    <View>
      <Text style={styles.text}>
        NOW THEREFORE, the condition of this obligation is such that if the
        Principal shall promptly pay all amounts which may be due by Principal
        to Florida Power & Light Company for utility services in the
        Principal&apos;s name at any or all premises, then this obligation shall
        be null and void; otherwise it shall remain in full force and effect.
      </Text>
    </View>

    <View>
      <Text style={styles.text}>
        PROVIDED FURTHER, that Principal and Surety jointly and severally agree
        that if at any time Principal&apos;s payment, or any part thereof, of
        Principal&apos;s obligations to Florida Power & Light Company is
        rescinded or must otherwise be restored or returned for any reason
        whatsoever (Including, but not limited to, insolvency, bankruptcy or
        reorganization), then the Surety obligation shall, to the extent of the
        payment rescinded or returned, be deemed to have continued in existence,
        notwithstanding such previous payment, and the Surety obligation shall
        continue to be effective or be reinstated, as the case may be, as to
        such payment, all as though such previous payment had never been made;
      </Text>
    </View>

    <View>
      <Text style={styles.text}>
        PROVIDED FURTHER, that regardless of the number of years this bond shall
        continue or be continued in force and of the number of premiums which
        shall be payable or paid, the Surety shall not be liable there under for
        a larger amount, in the aggregate, than the amount of this bond, unless
        suit must be brought for enforcement of the within obligations in which
        case the Surety will also be liable for all costs in connection
        therewith and reasonable attorneys’ fees, including costs of and fees
        for appeals; and
      </Text>
    </View>

    <View>
      <Text style={styles.text}>
        PROVIDED FURTHER, that should the Surety so elect, this bond may be
        canceled by the Surety as to subsequent liability by giving thirty (30)
        days’ notice in writing by certified mail-return receipt requested to{' '}
        <Text style={{ fontFamily: timesBold }}>
          Florida Power & Light Company RRD/LFO 4200 W Flagler St Miami, FL
          33134. The notice of cancellation shall not be effective unless it
          includes the Principal’s name and “Account Number:{' '}
          <Text style={styles.dynamicData}>
            {' '}
            {props.data.billAccount} &rdquo;{' '}
          </Text>{' '}
          written thereon.
        </Text>
      </Text>
      <Text>
        Signed, sealed and dated this ____________________ day of
        ____________________________________________, __________________.
      </Text>
    </View>

    <View style={styles.notary}>
      <View style={styles.subNotary}>
        <Text> </Text>
        <Text>CORPORATE</Text>
        <Text>SEAL</Text>
        <Text>(Principal)</Text>
      </View>
      <View style={[styles.subNotary, { lineHeight: 1.5, fontFamily: roman }]}>
        <Text>Principal __________________________________</Text>
        <Text>By __________________________________</Text>
        <Text>
          Title __________________________________,{' '}
          _____________________________________________
        </Text>
        <Text>
          (Corporate officer, Partner){'                        '}
          (General partner of limited partnership)
        </Text>
      </View>
      <View style={styles.subNotary}>
        <Text> </Text>
        <Text>NOTARY</Text>
        <Text>SEAL</Text>
        <Text>(Principal) </Text>
      </View>
    </View>

    <View>
      <Text style={[styles.title, { textDecoration: 'underline' }]}>
        NOTARY CERTIFICATE-PRINCIPAL SIGNATURE
      </Text>
    </View>

    <View style={{ lineHeight: 1.5 }}>
      <Text>
        STATE OF ______________________________________________________.
      </Text>
      <Text>
        COUNTY OF ______________________________________________________.
      </Text>
      <Text>
        SWORN TO and SUBSCRIBED before me this_____________________ day of
        ___________________________, ___________________.
      </Text>
      <Text>
        Notary Public: _______________________________________________.
      </Text>
      <Text>
        My Commission Expires: _______________________________________________.
      </Text>
    </View>

    <View>
      <Text style={styles.border}></Text>
    </View>

    <View style={styles.notary}>
      <View style={styles.subNotary}>
        <Text> </Text>
        <Text>CORPORATE</Text>
        <Text>SEAL</Text>
        <Text>(Surety)</Text>
      </View>
      <View style={[styles.subNotary, { lineHeight: 1.5, fontFamily: roman }]}>
        <Text>Surety __________________________________</Text>
        <Text>
          By (sign)__________________________________,
          (print)__________________________________
        </Text>
        <Text>
          (Designated in attached Power of Attorney. If not Florida resident,
          countersigned below){' '}
        </Text>
      </View>
      <View style={styles.subNotary}>
        <Text> </Text>
        <Text>NOTARY</Text>
        <Text>SEAL</Text>
        <Text>(Surety) </Text>
      </View>
    </View>

    <View>
      <Text style={[styles.title]}>NOTARY CERTIFICATE-SURETY SIGNATURE</Text>
    </View>

    <View style={{ lineHeight: 1.5 }}>
      <Text>
        STATE OF ______________________________________________________.
      </Text>
      <Text>
        COUNTY OF ___________________________________________________.
      </Text>
      <Text>
        SWORN TO and SUBSCRIBED before me this ________________ day of
        ___________________________, ___________________.
      </Text>
      <Text>
        My Commission Expires: _____________________________. Notary Public:
        _______________________________________________.
      </Text>
    </View>
  </View>
);

MediaComponent.propTypes = {
  data: PropTypes.shape({
    companyName: PropTypes.string,
    billAccount: PropTypes.number,
    district: PropTypes.number,
    taxId: PropTypes.number,
    street: PropTypes.string,
    streetline2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.number,
    depositDueDate: PropTypes.string,
    depositQuoteAmt: PropTypes.number,
    depositBondAmt: PropTypes.number,
    bondNumber: PropTypes.string,
    appStatus: PropTypes.string,
    depositAmtDiff: PropTypes.bool,
    insuranceCompanyName: PropTypes.string,
    insuranceCompanyStrAddr: PropTypes.string,
    insuranceCompanyStrAddrLn2: PropTypes.string,
    insuranceCompanyCity: PropTypes.string,
    insuranceCompanyState: PropTypes.string,
    insuranceCompanyZipCode: PropTypes.string,
  }),
};

const InstructionComponent = () => (
  <View style={[styles.content, { fontSize: 10, lineHeight: 2 }]}>
    <View style={styles.instruct}>
      <Text style={{ textDecoration: 'underline', fontFamily: timesBold }}>
        Instructions to complete the Surety Bond form:
      </Text>
    </View>

    <View style={styles.instruct}>
      <Text style={{ fontFamily: timesBold }}>Principal (FPL Customer)</Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}If incorporated, apply impression of corporate seal.
        Note: The corporate seal must agree with the corporation’s name on the
      </Text>
      <Text style={{ textIndent: 40 }}>Surety Bond.</Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}If there is no corporate seal, please indicate and
        write “NONE” in the designated space.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Have Corporate Officer sign the Surety Bond and enter
        title of signatory.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}If the company is a Limited Partnership (LP), Limited
        Liability Partnership (LLP), or Limited Liability Partnership (LLLP),
      </Text>
      <Text style={{ textIndent: 40 }}>
        the General Partner name must be included.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Notarize the Principal&rsquo;s signature. Do not alter
        name or date of Notary Certificate.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}The Notary must apply impression of seal and the seal
        must contain the name of the Notary Public.
      </Text>
    </View>
    <View style={styles.instruct}>
      <Text style={{ fontFamily: timesBold }}>Surety</Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Power of Atorney must be included with the Surety
        Bond.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}The typed date for both the Surety Notary Certificate
        and the Power of Attorney Notary Certificate MUST agree.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Notarize the Corporate Officer&rsquo;s signature. Do
        not alter name or date of Notary Certificate.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}The Notary must apply impression of seal and the seal
        must contain the name of the Notary Public.
      </Text>
    </View>
    <View style={styles.instruct}>
      <Text style={{ fontFamily: timesBold }}>Agent</Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Upload the completed signed and notarized application
        with Power of Attorney to the portal for final review.
      </Text>
      <Text style={{ textIndent: 40 }}>
        You will be notified by email when the review is completed.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Once the application has been approved, promptly send
        the original Surety Bond and Power of Attorney from Insurance/Surety
      </Text>
      <Text style={{ textIndent: 40 }}>Company, to:</Text>
      <Text style={{ textIndent: 40 }}>
        FPL, Attention: Deposit Administration RRD\LFO Deposit Administration,
        4200 W. Flagler Street, Coral Gables, FL 33134.
      </Text>
      <Text style={{ textIndent: 20 }}>
        {' '}
        &#8226; {'      '}Retain a copy for your records.
      </Text>
    </View>
  </View>
);

export function PdfDocument(props) {
  return (
    <Document>
      <Page style={styles.body} wrap>
        <InstructionComponent />
        <View style={styles.pageNumbers}>
          <Text
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
          <Text style={styles.formNumber}>{formName}</Text>
        </View>
      </Page>
      <Page style={styles.body} wrap>
        <MediaComponent data={props.data} />
        <View style={styles.pageNumbers}>
          <Text
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
          <Text style={styles.formNumber}>{formName}</Text>
        </View>
      </Page>
      {props.data.accounts && props.data.accounts.length > 0 && (
        <Page style={styles.body}>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Company Name</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Account No</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Address</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Deposit Quote</Text>
              </View>
            </View>

            {props.data.accounts &&
              props.data.accounts.map(a => (
                <View key={a.id} style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{a.accountName}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}> {a.accountNumber}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {a.accountMailingAddress}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {numberFormat(a.depositGuideAmt)}
                    </Text>
                  </View>
                </View>
              ))}
          </View>
          <View style={styles.pageNumbers}>
            <Text
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
            <Text style={styles.formNumber}>{formName}</Text>
          </View>
        </Page>
      )}
    </Document>
  );
}
PdfDocument.propTypes = {
  data: PropTypes.shape({
    map: PropTypes.func,
    accounts: PropTypes.shape({
      map: PropTypes.func,
      length: PropTypes.func,
    }),
  }),
};
